module.exports = __webpack_public_path__ + "static/media/triangularPrizm1.499bcaac.jpg";